import React, { Component } from 'react';

import {
  IonContent,
  IonHeader,
  IonTitle,
  IonPage,
  IonToolbar,
  IonButtons,
  IonBackButton,
  IonLabel,
  IonItem,
  withIonLifeCycle,
  IonButton,
} from '@ionic/react';

import ShopEvent from '../services/shopevent';
import ShopService from '../services/shopservice';

class EventDetails extends Component {
  constructor(props) {
    super(props);
    this.form = React.createRef();
    this.files = React.createRef();
    this.pickedDateRef = React.createRef('');
    this.selectedTimeRef = React.createRef('');
    this.selectedStaffIdRef = React.createRef('');
    this.noteRef = React.createRef('');
    this.date = React.createRef('');
    this.serviceRef = React.createRef('');
    this.profileRef = React.createRef('');

    this.state = {
      event: [],
      shopServiceModal: false,
      availableDate: [],
      pickedDateTime: null,
      isModalOpen: false,
      isActive: '',
      calendarDayProgression: [],
    };

    this.setService = this.setService.bind(this);
    this.textHandler = this.textHandler.bind(this);
    this.requestService = this.requestService.bind(this);
  }

  async ionViewWillEnter() {
    if (!!this.props.loader) this.props.loader.current.show();
    const { data } = this.props.match.params;

    await this.setService(this.props.match.params.id, false);
    this.setState({ eventDate: data });
    try {
      const { id } = this.props.match.params;
      let response = await ShopEvent.find(id);

      let {
        data: { data: event },
      } = response;

      this.setState({ event });
    } catch (e) {
      console.error(e);
    } finally {
      this.props.loader.current.dismiss();
    }
  }

  async ionViewWillLeave() {
    this.setState({ isModalOpen: false });
    this.setState({ pickedDateTime: null });
    this.setState({ availableDate: null });
    this.setState({ isActive: '' });
    this.setState({ calendarDayProgression: [] });

    this.serviceRef.current = '';
    this.profileRef.current = '';
    this.selectedTimeRef.current = '';
    this.pickedDateRef.current = '';
    this.selectedStaffIdRef.current = '';
    this.noteRef.current = '';
  }

  async textHandler(event) {
    await this.setState({ [event.target.name]: event.detail.value });
  }

  async setService(shop_service_id) {
    await this.setState({
      shop_service_id,
      shopServiceModal: true,
    });
  }

  async requestService(e) {
    try {
      let shopservice = {
        shop_service_id: this.state.shop_service_id,
        shop_service_name: this.state.event.find((service) => service.id === this.state.shop_service_id).name,
        note: this.state.note,
      };

      await ShopService.create(shopservice);
      this.setState({
        shop_service_id: undefined,
        note: '',
        shopServiceModal: false,
      });

      this.props.toast.current.add({
        message: `Richiesta inviata correttamente`,
      });
    } catch (error) {
      console.error(error);
      this.props.toast.current.add({
        message: `Impossibile inviare la richiesta`,
        color: 'warning',
      });
    }
  }

  async fetchDateTime(serviceId) {
    const { id, data } = this.props.match.params;

    this.props.history.push(`/app/eventReservation/${id}/${data}/${serviceId}`);
  }

  formatDate(date) {
    return new Date(date).toLocaleDateString('it-IT');
  }

  reset() {
    this.pickedDateRef.current = '';
    this.setState({ pickedDateTime: null });
    this.setState({ isActive: '' });
  }

  render() {
    const { event } = this.state;
    const { data } = this.props.match.params;
    const formattedDate = this.formatDate(data);

    return (
      <IonPage>
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
              <IonBackButton defaultHref="/app/events" />
            </IonButtons>

            <IonTitle>{event ? `Dettaglio Evento - ${event.name}` : 'Dettaglio Evento'}</IonTitle>
          </IonToolbar>
        </IonHeader>

        <IonContent className="ion-padding">
          {event ? (
            <p className="ion-padding-top ion-padding-start ion-padding-end">
              L'evento selezionato {event.name} si terra il {formattedDate}.
            </p>
          ) : null}

          {event?.service?.length ? (
            event.service.map((service, i) => (
              <IonItem key={service.id ?? i}>
                <IonLabel>
                  {!!service.image && (
                    <div className="ion-text-center">
                      <img
                        src={service.image_url}
                        alt={service.name}
                        style={{
                          height: '250px',
                          objectFit: 'cover',
                        }}
                      />
                    </div>
                  )}

                  <strong>{service.name}</strong>

                  <span className="ion-card-content m-top overflow-auto text-normal">
                    <div dangerouslySetInnerHTML={{ __html: service.description }} />
                  </span>

                  <p className="d_flex ion-justify-content-between m-top">
                    <span>{service.price} €</span>
                    <span>Min. {service.duration}</span>
                  </p>
                  <div className="ion-padding ion-text-center">
                    <IonButton
                      onClick={(e) => {
                        e.stopPropagation();
                        this.fetchDateTime(service.id);
                      }}
                    >
                      Prenota
                    </IonButton>
                  </div>
                </IonLabel>
              </IonItem>
            ))
          ) : (
            <p className="ion-padding-top ion-padding-start ion-padding-end">
              L'evento selezionato non ha servizi prenotabili al momento.
            </p>
          )}
        </IonContent>
      </IonPage>
    );
  }
}

export default withIonLifeCycle(EventDetails);
